export default "__VITE_ASSET__C5CL0zNB__"